import { apiUrl } from "../../../utils/api";
import { apiBasePath } from "../../BasicUrl";

const DeleveryData = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        getDeliverListApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.deliveryList}`,
                method: "POST",
                body: data,

            }),
        }),
        DeliverSearchApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.deliverySearch}`,
                method: "POST",
                body: data,
            })
        }),
        DeliverOrdersApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.deliveryorders}`,
                method: "POST",
                body: data
            }),
        }),
        DeliverInfosApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.deliveryInfo}`,
                method: "POST",
                body: data
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetDeliverListApiMutation, useDeliverInfosApiMutation, useDeliverSearchApiMutation, useDeliverOrdersApiMutation } = DeleveryData;